import Loadable from 'app/components/Loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const DataManipulation = Loadable(
  lazy(() => import('../pages/dataManipulation/index'))
)

const dataManipulationRoutes: RouteObject[] = [
  {
    path: '/data-manipulation',
    element: <DataManipulation />,
  },
]

export default dataManipulationRoutes
